import { Link } from "react-router-dom";
import { Logo } from "@/components/Navbar";
import { Phone, Mail, Globe, MapPin } from "lucide-react";

export default function Footer() {
  return (
    <footer className="relative mt-20 border-t border-white/10 bg-[#0A0A0A]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-14 grid gap-10 md:grid-cols-4">
        <div className="md:col-span-2">
          <Logo className="text-2xl" />
          <p className="mt-4 text-gray-400 max-w-sm">
            Impression 3D, lithophanies, figurines, objets personnalisés et pièces techniques.
            À Tenay, vos idées prennent vie.
          </p>
          <p className="mt-3 text-xs text-gray-600">SIRET : 50471513700072</p>
        </div>

        <div>
          <h4 className="font-heading font-bold text-white mb-4">Navigation</h4>
          <ul className="space-y-2 text-gray-400">
            <li><Link to="/boutique" className="hover:text-[#E6007E]">Boutique</Link></li>
            <li><Link to="/categories" className="hover:text-[#E6007E]">Catégories</Link></li>
            <li><Link to="/impression-fichier-3d" className="hover:text-[#E6007E]">Impression fichier 3D</Link></li>
            <li><Link to="/devis" className="hover:text-[#E6007E]">Demande de devis</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="font-heading font-bold text-white mb-4">Contact</h4>
          <ul className="space-y-3 text-gray-300">
            <li><a href="tel:+33635307284" data-testid="footer-call-chris" className="flex items-center gap-2 hover:text-[#E6007E]"><Phone className="w-4 h-4 text-[#E6007E]" /> Chris — 06 35 30 72 84</a></li>
            <li><a href="tel:+33781901248" data-testid="footer-call-nico" className="flex items-center gap-2 hover:text-[#E6007E]"><Phone className="w-4 h-4 text-[#0055FF]" /> Nico — 07 81 90 12 48</a></li>
            <li><a href="mailto:tenay.ain.pression@gmail.com" className="flex items-center gap-2 hover:text-[#E6007E]"><Mail className="w-4 h-4 text-[#E6007E]" /> tenay.ain.pression@gmail.com</a></li>
            <li><span className="flex items-center gap-2"><Globe className="w-4 h-4 text-[#0055FF]" /> www.tenay-ain-pression.fr</span></li>
            <li><span className="flex items-center gap-2"><MapPin className="w-4 h-4 text-[#E6007E]" /> Tenay, Ain (01)</span></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/10 py-5 text-center text-sm text-gray-600">
        © {new Date().getFullYear()} Tenay Ain-Pression — Impression 3D · Création · Innovation
      </div>
    </footer>
  );
}
